import { jsx } from "react/jsx-runtime";
import { RequiredIndicatorPlacement, RequiredIndicator } from "@wix/ambassador-forms-v4-form/types";
import { Node_Type } from "@wix/ricos";
import classNames from "classnames";
import cloneDeep from "lodash/cloneDeep";
import { useMemo } from "react";
import { useTranslation } from "../../contexts/translation-context.js";
import { useRicosTheme } from "../../theme/ricos-theme-utils.js";
import RicosViewer from "../ricos-viewer/ricos-viewer.js";
import styles from "./field-rich-label.module.scss";
function requiredIndicatorText(requiredIndicatorType, t) {
  switch (requiredIndicatorType) {
    case RequiredIndicator.ASTERISK:
      return "*";
    case RequiredIndicator.TEXT:
      return t("settings.required-indicator-text");
    default:
      return "";
  }
}
const FieldRichLabel = ({
  label,
  required,
  disabled,
  requiredIndicatorType = RequiredIndicator.ASTERISK,
  requiredIndicatorPlacement = RequiredIndicatorPlacement.AFTER_FIELD_TITLE,
  ricosTheme,
  requiredIndicatorClassName
}) => {
  const customTheme = useRicosTheme(ricosTheme);
  const { t } = useTranslation();
  const indicator = requiredIndicatorText(requiredIndicatorType, t);
  const labelWithIndicator = useMemo(() => {
    if (!required) {
      return label;
    }
    const str = (v) => ({ stringValue: v });
    const indicatorNode = {
      type: Node_Type.EXTERNAL,
      id: "",
      nodes: [],
      externalData: {
        fields: {
          "aria-hidden": str("true"),
          className: str(
            classNames(styles.indicator, requiredIndicatorClassName)
          )
        }
      },
      textData: {
        text: indicator,
        decorations: []
      }
    };
    const result = cloneDeep(label);
    switch (requiredIndicatorPlacement) {
      case RequiredIndicatorPlacement.BEFORE_FIELD_TITLE:
        const firstNode = result?.nodes.find(Boolean);
        if (firstNode) {
          firstNode.nodes ??= [];
          firstNode.nodes.unshift(indicatorNode);
        }
        break;
      case RequiredIndicatorPlacement.AFTER_FIELD_TITLE:
        const lastNode = result?.nodes?.findLast(Boolean);
        if (lastNode) {
          lastNode.nodes ??= [];
          lastNode.nodes.push(indicatorNode);
        }
        break;
    }
    return result;
  }, [
    required,
    requiredIndicatorClassName,
    indicator,
    label,
    requiredIndicatorPlacement
  ]);
  return useMemo(
    () => /* @__PURE__ */ jsx(
      RicosViewer,
      {
        content: labelWithIndicator,
        className: classNames(styles.root, {
          [styles.disabled]: disabled,
          [styles.indicatorBeforeLabel]: requiredIndicatorPlacement === RequiredIndicatorPlacement.BEFORE_FIELD_TITLE,
          [styles.indicatorAfterLabel]: requiredIndicatorPlacement === RequiredIndicatorPlacement.AFTER_FIELD_TITLE
        }),
        customTheme
      }
    ),
    [disabled, requiredIndicatorPlacement, labelWithIndicator, customTheme]
  );
};
export {
  FieldRichLabel
};
//# sourceMappingURL=field-rich-label.js.map
